import React from 'react'
import { useNavigate } from 'react-router-dom'

export default function Unauthorized() {
  const navigate = useNavigate()

  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center text-center"
      style={{ minHeight: '70vh', padding: '2rem' }}
    >
      <div style={{ fontSize: '3rem', marginBottom: '1rem' }} aria-hidden="true">
        &#128274;
      </div>
      <h2 className="mb-2">Access Denied</h2>
      <p className="text-muted mb-4">
        You don't have permission to view this page.
      </p>
      <button
        type="button"
        className="btn btn-primary"
        onClick={() => navigate(-1)}
      >
        Go Back
      </button>
    </div>
  )
}
